import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useNavigation from '@/hooks/useNavigation';
import useParams from '@/hooks/useParams';
import AttachTagsModal from '@/modules/corporate/modules/tags/components/AttachTagsModal';
import routes from '@/pages/corporate/routes';
import { EntityTagsInput, Maybe, TagAvailableOnEnum } from '@/types/schema';

import { SurveySettingsDialogProps } from '../../types';

const TAGS_AVAILABLE_ON = [TagAvailableOnEnum.Content];

const TagsDialog: React.FC<SurveySettingsDialogProps> = (props) => {
  const { t } = useTranslation();
  const { initialSurvey, onClose, onSubmit } = props;
  const navigation = useNavigation();
  const { validationError, surveyId, ...query } = useParams<Record<string, string>>();

  const tags = useMemo(() => initialSurvey.tags || [], [initialSurvey.tags]);

  const onTagsSubmit = useCallback(
    (nextTags?: Maybe<EntityTagsInput>) => {
      onSubmit({ tags: nextTags });
      navigation.replace(routes.SurveyEditor(initialSurvey.id!), {
        query,
        appendQuery: false,
      });
      return Promise.resolve(true);
    },
    [initialSurvey.id, navigation, onSubmit, query],
  );

  return (
    <AttachTagsModal
      availableOn={TAGS_AVAILABLE_ON}
      contentName={t('Common:ResourceTypeSM.Survey')}
      hasError={validationError === 'tag'}
      subWorkspaceIds={initialSurvey.subWorkspaces ?? []}
      tags={tags}
      onClose={onClose}
      onSubmit={onTagsSubmit}
    />
  );
};

export default TagsDialog;
